import { render, staticRenderFns } from "./ChatApp.vue?vue&type=template&id=05567c6e&scoped=true&lang=pug"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"
import style0 from "./ChatApp.vue?vue&type=style&index=0&id=05567c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05567c6e",
  null
  
)

export default component.exports